export default __webpack_public_path__ + "static/eh_logo-a56f30181e5c1a413e0582745a0589a7.svg";